// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubtitlesPlayer-modulewrapper2lr","subtitles":"SubtitlesPlayer-modulesubtitles2Il"};